import * as Sentry from '@sentry/react'

const UNKNOWN_MESSAGE = 'An unknown error occured'

/**
 * Gets a message for display from the provided error object.
 *
 * @param {*} err Can be any object or `Error` with a `message` property.
 * `ApolloError`s will be handled specially to check for graphql or network errors.
 * @returns {string}
 */
export const getMessage = err => {
  if (!err) {
    return UNKNOWN_MESSAGE
  }

  if (err.graphQLErrors && err.graphQLErrors.length) {
    return err.graphQLErrors[0].message || UNKNOWN_MESSAGE
  }

  if (err.networkError && err.networkError.message) {
    return err.networkError.message || UNKNOWN_MESSAGE
  }

  // TODO Do we want to return `err` directly if it's a string?
  return err.message || UNKNOWN_MESSAGE
}

/**
 *
 * Gets the retry message from an error
 * This is nonstandard, and only to be used to display retries in the
 * Error component
 */
export const getRetryMessage = err => {
  if (!err) {
    return null
  }
  return err && err.retryMessage
}

/**
 * Logs the provided error to sentry.
 * @param {*} err See `getMessage()`
 */
export const logError = err => {
  if (process.env.NODE_ENV === 'DEVELOPMENT') {
    console.error(err)
  }

  const message = getMessage(err)

  Sentry.withScope(scope => {
    scope.setLevel(Sentry.Severity.Warning)

    if (err instanceof Error) {
      Sentry.captureException(err)
    } else {
      scope.setExtra('error', err)
      Sentry.captureMessage(message)
    }
  })
}
